import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { OrderItemCardWrapper } from "../../components/OrderItemCard";
export var NotRelatedToOrderButtonConditionally = function NotRelatedToOrderButtonConditionally(_ref) {
  var focused = _ref.focused,
    brandOrders = _ref.brandOrders,
    searchText = _ref.searchText,
    onClick = _ref.onClick;
  return brandOrders.length === 1 && searchText === "" && !focused ? ( /*#__PURE__*/React.createElement(NotRelatedToOrderButton, {
    onClick: onClick
  })) : null;
};
var NotRelatedToOrderButton = function NotRelatedToOrderButton(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(OrderItemCardWrapper, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subheadingSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "kWjTPY",
    defaultMessage: [{
      "type": 0,
      "value": "Non, ce n'est pas en lien avec une commande"
    }]
  })));
};